import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const bullets = ['Entras a reuniones donde se habla de IA y por primera vez entiendes de qué están hablando.', 'Tus hijos o nietos te ven diferente — como alguien que está al día con el mundo.', 'Cuando alguien menciona ChatGPT sabes responder con claridad y sin nervios.', 'Usas la IA para resolver en minutos lo que antes te tomaba horas — redactar un correo, buscar información, organizar una idea.', 'Dejas de depender de otros para entender las noticias sobre tecnología.', 'Le haces preguntas a la IA por tu cuenta, con tus propias palabras, y obtienes respuestas útiles.', 'Dejas de sentir que el mundo digital avanza sin ti.', 'Recuperas la confianza de hablar sobre tecnología sin miedo a equivocarte.', 'Te conviertes en el punto de referencia de tu familia o entorno cuando alguien pregunta sobre IA.', 'Por primera vez en años sientes que entiendes hacia dónde va el mundo — y que formas parte de ese futuro.'];
export function TransformationSection() {
  return <section className="w-full bg-crema pt-14 md:pt-[88px] pb-8 md:pb-12 px-6" data-id="element-233">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[680px] mx-auto flex flex-col items-center" data-id="element-234">
        <h2 className="text-[30px] md:text-[36px] font-serif font-bold text-navy leading-[1.3] text-center" data-id="element-235">
          ¿Cómo se ve tu vida después
          <br data-id="element-236" />
          de leer este libro?
        </h2>

        <ul className="mt-10 space-y-5 w-full" data-id="element-237">
          {bullets.map((bullet, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex items-start gap-3.5" data-id="element-238">
              <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-burnt/10 flex items-center justify-center" data-id="element-239">
                <CheckIcon className="w-4 h-4 text-burnt" strokeWidth={3} data-id="element-240" />
              </span>
              <span className="text-[16px] font-sans text-[#4A4A4A] leading-[1.75]" data-id="element-241">
                {bullet}
              </span>
            </motion.li>)}
        </ul>

        <motion.a href="#offer" whileHover={{
        scale: 1.02,
        filter: 'brightness(0.92)'
      }} whileTap={{
        scale: 0.98
      }} className="mt-10 bg-burnt text-white font-sans font-bold text-[17px] rounded-lg py-[18px] px-[44px] shadow-[0_4px_20px_rgba(230,126,34,0.35)] transition-all duration-200 w-full sm:w-auto inline-block text-center no-underline" data-id="element-242">
          Yo, quiero eso para mí &rarr;
        </motion.a>
      </motion.div>
    </section>;
}